import {FC} from "react";
import {Box, Button, Drawer, Stack, SxProps, Typography, useMediaQuery, useTheme} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DrawerContent from "./DrawerContent";
import {useSSTranslation} from "@/i18n/useSSTranslation";

interface StreakDrawerProps {
	open: boolean;
	streakDays: number;
	onContinue: () => void;
}

const StreakDrawer: FC<StreakDrawerProps> = ({
	open,
	streakDays,
	onContinue
}) => {
	const theme = useTheme();
	const {t} = useSSTranslation();
	const isEqualsOrGreaterThanLarge = useMediaQuery(theme.breakpoints.up("md"));
	const buttonFullWidth = !isEqualsOrGreaterThanLarge;

	const handleCloseDrawer = () => {
		onContinue();
	}

	const drawerStyle : SxProps = {
		"& .MuiDrawer-paper": {
			borderTopLeftRadius: isEqualsOrGreaterThanLarge ? 0 : "32px",
			borderTopRightRadius: isEqualsOrGreaterThanLarge ? 0 : "32px"
		}
	}

	const contentWrapperStyle: SxProps = {
		height: isEqualsOrGreaterThanLarge ? "100vh" : "calc(100vh - 64px)",
		backgroundColor: theme.palette.background.paperElevation2,
		justifyContent: "center",
		borderTop: isEqualsOrGreaterThanLarge ? `5px solid ${theme.palette.primary.main}` : undefined,
		position: "relative"
	}

	const headerStyle: SxProps = {
		width: "100%",
		justifyContent: "space-between",
		alignItems: "center",
		padding: "25px 0",
		position: "absolute",
		top: 0
	}

	const iconStyle: SxProps = {
		paddingRight: "20px",
		cursor: "pointer",
		color: theme.palette.action.active
	}

	const buttonWrapperStyle: SxProps = {
		justifyContent: "center",
		alignItems: "center",
		height: "106px",
		borderTop: isEqualsOrGreaterThanLarge ? `1px solid ${theme.palette.divider}` : "none",
		padding: "0 25px"
	}

	const buttonStyle: SxProps = {
		color: theme.palette.primary.contrastText,
		fontSize: "15px",
		height: "42px"
	}

	const congratsLabelStyle: SxProps = {
		fontSize: "24px",
		fontWeight: 400,
		paddingLeft: "20px"
	}

	const footerStyle: SxProps = {
		position: "fixed",
		bottom: 0,
		width: "100%",
		paddingBottom: isEqualsOrGreaterThanLarge ? 0 : "25px"
	}

	return (
		<Drawer
			anchor="bottom"
			open={open}
			sx={drawerStyle}
		>
			<Stack
				sx={contentWrapperStyle}
			>
				<Stack
					direction="row"
					sx={headerStyle}
				>
					<Typography
						sx={congratsLabelStyle}
					>
						{`${t("common_congrats", "Congrats")}!`}
					</Typography>
					<CloseIcon
						fontSize="small"
						onClick={handleCloseDrawer}
						sx={iconStyle}
					/>
				</Stack>
				<DrawerContent streakDays={streakDays} />
				<Box
					sx={footerStyle}
				>
					<Stack
						direction="row"
						sx={buttonWrapperStyle}
					>
						<Button
							variant="contained"
							fullWidth={buttonFullWidth}
							sx={buttonStyle}
							onClick={onContinue}
						>
							{t("common_continue", "Continue").toUpperCase()}
						</Button>
					</Stack>
				</Box>
			</Stack>
		</Drawer>
	)
}

export default StreakDrawer;

